import { render, staticRenderFns } from "./OrderCustomerinfo.vue?vue&type=template&id=6215d2d6&scoped=true&"
import script from "./OrderCustomerinfo.vue?vue&type=script&lang=js&"
export * from "./OrderCustomerinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6215d2d6",
  null
  
)

export default component.exports